import * as React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@material-ui/core";
import { withStyles, styled } from "@material-ui/core/styles";
import clsx from "clsx";

const StyledButton = withStyles((theme) => ({
  root: {
    background: theme.palette.background.paper,
    boxShadow: theme.boxShadow.elevation1,
    borderRadius: theme.shape.full,
    position: "relative",
    padding: "0 12px",
    minWidth: "unset",
    height: 32,
    transition: "all 150ms ease",
    "&:hover": {
      background: theme.palette.background.paper,
      boxShadow: theme.boxShadow.elevation2,
    },
    "&.selected": {
      background: theme.palette.grey.main,
      boxShadow: "none",
    },
  },
  endIcon: {
    position: "absolute",
    top: -7,
    right: -4,
  },
}))(Button);

const SoftButton = React.memo(function SoftButton({
  children,
  selected = false,
  ...buttonProps
}) {
  return (
    <StyledButton {...buttonProps} className={clsx(selected && "selected")}>
      <StyledTypography
        component="div"
        className={clsx(selected && "selected")}
      >
        {children}
      </StyledTypography>
    </StyledButton>
  );
});

SoftButton.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.medium,
  fontSize: theme.typography.pxToRem(13),
  "&.selected": {
    color: theme.palette.getContrastText(theme.palette.grey.main),
  },
}));

export default SoftButton;
